// Loads the Firesheet V3 (WASM) bundles from public/assets/libs/firesheet3.
//
// Three files matter for a headless instance:
//   firesheet-ui.js  — ESM; registers the <firesheet-ui> custom element
//   firesheet-lib.js — IIFE; sets window.FiresheetInstance
//   firesheet-app.js — IIFE; sets window.FiresheetApp, whose init() adapter is the
//                      ONLY source of the 'range' CustomEvent.
//
// fs-ribbon.js is still not loaded: these dialogs run with toolbar/fxbar off.
//
// @vite-ignore keeps Vite from trying to resolve these public assets at build time.

const BUNDLE_BASE = '/assets/libs/firesheet3';

let loading: Promise<void> | null = null;

/** Idempotent — every caller after the first awaits the same load. */
export const loadFiresheet3 = (): Promise<void> => {
  if (!loading) {
    loading = (async () => {
      await import(/* @vite-ignore */ `${BUNDLE_BASE}/firesheet-ui.js`);
      await import(/* @vite-ignore */ `${BUNDLE_BASE}/firesheet-lib.js`);
      await import(/* @vite-ignore */ `${BUNDLE_BASE}/firesheet-app.js`);
      await customElements.whenDefined('firesheet-ui');
    })();
  }
  return loading;
};

export const firesheet3Urls = {
  workerUrl: `${BUNDLE_BASE}/firesheet-worker.js`,
  wasmUrl: `${BUNDLE_BASE}/firesheet_engine.wasm`
};
